import React, { FC } from 'react';
import css from './styles.module.scss';
import { useLogoTypeInfo } from './hook';

const LogoType: FC = () => {
  const { logo } = useLogoTypeInfo();

  if (!logo) {
    return null;
  }

  return (
    <div
      className={css.logo}
      style={{
        backgroundImage: `url("${logo}")`,
      }}
    />
  );
};

export default LogoType;
